var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 516,
    viewBox: "0 0 478 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M766.998 386.364C717.381 446.026 615.061 372.618 470.041 409.048C344.438 440.615 338.903 517.023 237.942 515.53C164.183 514.453 82.9111 473.72 37.095 400.585C-13.4312 319.949 2.37557 236.33 6.88435 216.024C27.003 124.945 91.7284 75.6738 114.575 58.8284C208.703 -10.5331 316.305 -1.19213 367.925 3.26331C561.831 20.0621 772.042 153.461 784.667 303.389C786.338 323.017 789.395 359.423 766.998 386.364Z",
    fill: "url(#paint0_linear_58_282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_282",
    x1: 287.009,
    y1: 635.124,
    x2: 468.152,
    y2: 44.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEEFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorTwo);
export default __webpack_public_path__ + "static/media/Vector-two.399608d7f9278f71b8f1300e4ac0f6fb.svg";
export { ForwardRef as ReactComponent };